import { isRouteErrorResponse, useRouteError } from 'react-router-dom'
import { Button, ErrorState } from '@/components/ui'

export function RouteErrorBoundary() {
  const error = useRouteError()
  const title = isRouteErrorResponse(error) ? `${error.status} ${error.statusText}` : 'Something went wrong'
  const message = isRouteErrorResponse(error) ? error.data : error instanceof Error ? error.message : undefined
  return (
    <div style={{ minHeight: '60vh', display: 'grid', placeItems: 'center', padding: 24 }}>
      <div>
        <ErrorState title={title} error={message ? new Error(String(message)) : undefined} />
        <div style={{ display: 'flex', justifyContent: 'center', gap: 8 }}>
          <Button variant="secondary" onClick={() => window.location.reload()}>
            Reload
          </Button>
          <Button to="/">Back to the board</Button>
        </div>
      </div>
    </div>
  )
}
